import { Box, Container, Grid, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router'

const Footer = () => {
    const navigate = useNavigate()
    const theme = useTheme()

    return (
        <>
            <Box
                sx={{
                    pt: { lg: "40px", md: "40px", sm: "20px", xs: "10px" },
                    pb: { lg: "40px", md: "40px", sm: "20px", xs: "10px" },
                    background: "#deedee"
                }}
            >
                <Container>
                    <Grid container spacing={{ lg: 2, md: 2, sm: 2, xs: 1 }}>
                        <Grid item lg={5} md={5} sm={12} xs={12} sx={{ textAlign: { lg: 'start', md: "start", sm: "center", xs: 'center' } }}>
                            <Box sx={{ width: { lg: '100%', md: "100%", sm: '50%', xs: '100%' }, margin: 'auto' }}>
                                <img
                                    src="/images/Frame-1000008385.png"
                                    alt="logo"
                                    width={"100%"}
                                    style={{ maxWidth: "460px" }}
                                />
                            </Box>

                        </Grid>
                        <Grid item lg={7} md={7} sm={12} xs={12} >
                            <Box display={"flex"} justifyContent={"space-between"} sx={{ gap: { lg: 8, md: 5, sm: 5, xs: 2 } }}>
                                <Box sx={{ maxWidth: { lg: "620px", md: "620px", sm: "520px", xs: "520px" } }} >
                                    <Typography
                                        color={"primary"}
                                        fontWeight={500}
                                        fontSize={{ lg: "26px", md: "26px", sm: '24px', xs: '20px' }}
                                    >
                                        Address
                                    </Typography>
                                    <Typography sx={{
                                        fontSize: { lg: "20px", md: "14px", sm: "13x", xs: "12px" },
                                    }} lineHeight={{ lg: "30px", md: "25px", sm: '20px', xs: '20px' }}>
                                        Vibhag-B, Samast Patidar Samaj Trust Surat, <br /> Shreemati M.M. Kheni Bhavan, Opp. Ankur Vidhyalaya,
                                        Ambatalavdi, Katargam, Surat - 395004, Gujarat, India
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography
                                        color={"primary"}
                                        fontWeight={500}
                                        fontSize={{ lg: "26px", md: "26px", sm: '24px', xs: '20px' }}
                                    >
                                        Contacts
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <img
                                            src="/images/call.svg"
                                            alt="logo"
                                            style={{ width: "20px", objectFit: "cover" }}
                                        />
                                        <Typography sx={{ whiteSpace: 'nowrap', fontSize: { lg: "20px", md: "14px", sm: "14px", xs: "14px" }, lineHeight: '42px', fontWeight: '400' }} > +91 98498 76476</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <img
                                            src="/images/call.svg"
                                            alt="logo"
                                            style={{ width: "20px", objectFit: "cover" }}
                                        />
                                        <Typography sx={{ whiteSpace: 'nowrap', fontSize: { lg: "20px", md: "14px", sm: "14px", xs: "14px" }, lineHeight: '42px', fontWeight: '400' }} >   +91 99499 21021</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <img
                                            src="/images/sms-tracking.svg"
                                            alt="logo"
                                            style={{ width: "20px", objectFit: "cover" }}
                                        />
                                        <Typography sx={{ whiteSpace: 'nowrap', fontSize: { lg: "20px", md: "14px", sm: "14px", xs: "14px" }, lineHeight: '42px', fontWeight: '400' }} >  info@ppsk.life</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12} ml={"auto"}>
                            <Box display={"flex"} alignItems={"center"} sx={{ justifyContent: { lg: 'start', md: "start", sm: 'center', xs: 'center' } }} mt={{ lg: 2, md: 2, sm: 1, xs: 0 }}>
                                <img src="/images/Instagram.svg" alt="logo" onClick={() => {
                                    window.open("https://www.instagram.com/ppsk_official?igsh=MTd0ZzY2ZDU0OThncA==")
                                }} style={{ cursor: 'pointer' }} />
                                <img src="/images/Facebook.svg" alt="logo" onClick={() => {
                                    window.open("https://www.facebook.com/people/%E0%AA%AA%E0%AA%BE%E0%AA%9F%E0%AB%80%E0%AA%A6%E0%AA%BE%E0%AA%B0-%E0%AA%AA%E0%AA%B0%E0%AA%BF%E0%AA%B5%E0%AA%BE%E0%AA%B0-%E0%AA%B8%E0%AB%81%E0%AA%B0%E0%AA%95%E0%AB%8D%E0%AA%B7%E0%AA%BE-%E0%AA%95%E0%AA%B5%E0%AA%9A-ppsk/61569671454063/")
                                }} style={{ cursor: 'pointer' }} />
                                <img src="/images/Youtube.svg" alt="logo" onClick={() => {
                                    window.open("https://www.youtube.com/@PatidarParivarSurakshaKavachPP")
                                }} style={{ cursor: 'pointer' }} />
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <Box
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    padding: { lg: '14px 0px', md: '14px 0px', sm: '10px 0px', xs: '10px 0px' }
                }}
            >
                <Container>
                    <Grid container>
                        <Grid item lg={4} md={4} sm={12} xs={12}>
                            <Box display={'flex'} alignItems={"center"} gap={2} sx={{ justifyContent: { lg: 'start', md: "start", sm: 'center', xs: 'center' } }}>
                                <Typography color={"white"} sx={{
                                    fontSize: { lg: "16px", md: "14px", sm: "13x", xs: "12px" },
                                    lineHeight: "30px",
                                    cursor: 'pointer'
                                }} onClick={() => navigate("/privacy-policy")}>
                                    Privacy Policy
                                </Typography>
                                <Typography color={"white"} sx={{
                                    fontSize: { lg: "16px", md: "14px", sm: "13x", xs: "12px" },
                                    lineHeight: "30px",
                                    cursor: 'pointer'
                                }} onClick={() => navigate("/terms-and-conditions")}>
                                    Terms & Condition
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item lg={8} md={8} sm={12} xs={12} sx={{ textAlign: { lg: 'end', md: 'center', sm: 'center', xs: 'center' } }}>
                            <Typography color={"white"} sx={{
                                fontSize: { lg: "18px", md: "14px", sm: "13x", xs: "12px" },
                                lineHeight: { lg: "30px", md: "25px", sm: '20px', xs: '20px' },
                                fontWeight: 400
                            }}>
                                © 2025  SAMAST PATIDAR SAMAJ TRUST Managed by Patidar Parivar Suraksha Kavach. All Rights Reserved.
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    )
}

export default Footer